import * as Sentry from '@sentry/vue'
import type { User } from '@/api/client'

// Единая точка установки/сброса Sentry user-context. Зовётся из стора auth при
// каждой смене сессии (login / fetchMe / refresh / имперсонация / logout) — чтобы
// ошибки в Sentry всегда были привязаны к актуальному юзеру, а не к hint'у из
// localStorage на момент инициализации. Под имперсонацией context — это сотрудник,
// под которым реально работают (его id и видит юзер в UI). Только id — при
// sendDefaultPii: false email/имя в Sentry не отправляем (тот же периметр, что
// на бэке, LOW-10); для группировки ошибок по юзеру id достаточно.
export function setSentryUser(user: Pick<User, 'id'>): void {
  Sentry.setUser({ id: user.id })
}

// Сессия закончилась (logout / потеря сессии): снимаем привязку, чтобы
// последующие анонимные ошибки не приписывались вышедшему юзеру.
export function clearSentryUser(): void {
  Sentry.setUser(null)
}
